export const fmtPLPhone = (value) => {
    const digits = String(value || '').replace(/\D+/g, '');

    let rest = digits.startsWith('48')
        ? digits.slice(2)
        : digits;

    rest = rest.slice(0, 9);

    const parts = [
        rest.slice(0, 3),
        rest.slice(3, 6),
        rest.slice(6, 9),
    ].filter(Boolean);

    return parts.length
        ? `+48 ${parts.join(' ')}`
        : '';
};
